/**
 * The one rule for what a price type charges. Every screen, total and document
 * that turns a price into an amount goes through here.
 *
 * Only 'per person' (any case: activities store 'Per Person', add-ons and F&B
 * arrive lowercased) is multiplied by the headcount. 'Per Unit',
 * 'per resource', an empty value and anything unknown are charged once. A
 * once-charged item still carries the activity's headcount in
 * `participantCount`, so multiplying by it without asking printed a fixed tour
 * guide fee as "8 × € 150" (ELI-372).
 *
 * Kept free of imports so any booking module can use it without a cycle. The
 * ESLint `no-restricted-syntax` rule rejects a hand-written comparison against
 * the literal elsewhere.
 */
const PER_PERSON = 'per person';

export const isChargedPerPerson = (priceVariant?: string | null): boolean =>
  String(priceVariant ?? '')
    .trim()
    .toLowerCase() === PER_PERSON;

/** How many times the price is charged: the headcount per person, else once. */
export const chargedQuantity = (
  participantCount: number,
  priceVariant?: string | null
): number => (isChargedPerPerson(priceVariant) ? participantCount : 1);

/** What the line costs: price × headcount per person, else the price once. */
export const chargedTotal = (
  price: number,
  participantCount: number,
  priceVariant?: string | null
): number => price * chargedQuantity(participantCount, priceVariant);
